export enum Scope {
  LIBRARY_ACCESS = 'LIBRARY_ACCESS',
  LIBRARY_ADMIN = 'LIBRARY_ADMIN',
  RESOURCE_ACCESS = 'RESOURCE_ACCESS',
  RESOURCE_ADMIN = 'RESOURCE_ADMIN',
  DISCOVER_ACCESS = 'DISCOVER_ACCESS',
  DISCOVER_ADMIN = 'DISCOVER_ADMIN',
  DESTINY_AI = 'DESTINY_AI',
  TITLEWAVE_ACCESS = 'TITLEWAVE_ACCESS',
  COMMUNITY_ACCESS = 'COMMUNITY_ACCESS',
  ONLINE_STORE_ACCESS = 'ONLINE_STORE_ACCESS',
  DESTINY_BACKOFFICE_ADMIN = 'DESTINY_BACKOFFICE_ADMIN',
  DESTINY_BACKOFFICE_ACCESS = 'DESTINY_BACKOFFICE_ACCESS',
  GUEST = 'GUEST',
  FUNDRAISING_MANAGER = 'FUNDRAISING_MANAGER',
  MASTERLIBRARY_DRAWINGS = 'MASTERLIBRARY_DRAWINGS',
  MASTERLIBRARY_SCHEDULES = 'MASTERLIBRARY_SCHEDULES',
  MASTERLIBRARY_WORKORDERS = 'MASTERLIBRARY_WORKORDERS',
  MASTERLIBRARY_HELPDESK = 'HELP_DESK',
  MASTERLIBRARY_ITAM = 'MASTERLIBRARY_ITAM'
}

export default Scope;
